<div class="shell">
  <!-- Left rail (persistent >=900px; off-canvas drawer <=900px). The shell owns
       the drawer positioning + open state; the sidebar owns its own content. -->
  <div class="shell__sidebar" [class.shell__sidebar--open]="nav.drawerOpen()">
    <app-sidebar></app-sidebar>
  </div>

  <!-- Backdrop scrim: rendered only in drawer mode (<=900px); click to close. -->
  <div
    class="shell__backdrop"
    [class.shell__backdrop--visible]="nav.drawerOpen()"
    data-testid="shell-drawer-backdrop"
    (click)="nav.close()"
    aria-hidden="true"
  ></div>

  <!-- Right column: top strip over the scrolling content area. -->
  <div class="shell__main">
    <app-topbar></app-topbar>
    <div class="shell__content">
      <!-- CON-96: shown only while the stored profile says the address could
           not be verified; renders nothing otherwise. -->
      <app-address-verification-banner></app-address-verification-banner>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
